import React, { useEffect, useState } from "react";
import { API_URL, getUser } from "../../../utils/Common";
import axios from "axios";
import MyLoader from "../../sharecomponents/MyLoader";
import {
  Header,
  Dropdown,
  Form,
  Table,
  Input,
  Button,
} from "semantic-ui-react";

// import { TestComponent } from "../../sharecomponents/TestComponent";

const initForm = Object.freeze({
  planid: "",
  ranchoid: "",
  valvulaid: "",
  cantidad_flores: "",
  cama_inicial: "",
  cama_final: "",
  ci_metros: "0",
  cf_metros: "0",
  formula: "",
  sem_fert: "",
});

const PlanesEjecucion = (props) => {
  const [loader, setLoader] = useState(false);
  const [planes, setPlanes] = useState([]);
  const [planesDrop, setPlanesDrop] = useState([]);
  const [planSelect, setPlanSelect] = useState(null);
  const [ranchos, setRanchos] = useState([]);
  const [valvulas, setValvulas] = useState([]);
  const [infoVal, setInfoVal] = useState(null);
  const [user, setUser] = useState(null);
  // -- formulario
  const [form, setForm] = useState(initForm);

  useEffect(() => {
    getPlanes();
    getRanchos();
    setUser(getUser());
  }, []);

  function getPlanes() {
    axios
      .get(API_URL + "/getPlanesEjecucion")
      .then((r) => {
        setPlanes(r.data.planes);
        setPlanesDrop(r.data.planesDrop);
      })
      .catch((e) => console.log(e));
  }

  function getRanchos() {
    axios
      .get(API_URL + "/getRanchoDrop")
      .then((r) => {
        setRanchos(r.data.ranchoDrop);
      })
      .catch((e) => console.log(e));
  }

  const handleChange = (e, { name, value }) => {
    setForm({
      ...form,
      [name]: value,
    });
    console.log(name, value);
    if (name === "planid") {
      // --- buscando el plan para calcular cuantas camas se necesita
      const p = planes.find((i) => +i.id === +value);
      if (p) {
        setPlanSelect(p);
        let f = { ...form };
        f.planid = value;
        f.cantidad_flores = p.floresreq;
        setForm({ ...f });
      }
    }
    // --- consulta de las valvulas
    if (name === "ranchoid") {
      getValvulas(value);
      setInfoVal(null);
    }

    if (name === "valvulaid") {
      form.valvulaid = value;
      setForm({ ...form });
      getInfoVal(value);
    }
  };

  const getValvulas = (ranchoid) => {
    axios
      .get(API_URL + "/getValvulas", { params: { ranchoid } })
      .then((r) => {
        console.log(r.data);
        setValvulas(r.data.valvulasDrop);
      })
      .catch((e) => console.log(e));
  };

  const getInfoVal = (valvulaid) => {
    axios
      .get(API_URL + "/getInfoValvula", { params: { valvulaid } })
      .then((r) => {
        console.log(r.data);
        setInfoVal({ ...r.data.valvula });
        console.log(infoVal);
        let f = { ...form };
        f.ci_metros = r.data.valvula.mt2_cama;
        f.cf_metros = r.data.valvula.mt2_cama;
        setForm({ ...f });
      });
  };

  const asignar = () => {
    setLoader(true);
    axios
      .post(API_URL + "/setInventarioCampo", { ...form, infoVal })
      .then((r) => {
        setLoader(false);
        setForm(initForm);
        getPlanes();
      })
      .catch((e) => {
        setLoader(false);
      });
  };

  /*const goAsigancion = (p) => {
       // props.history.push("/asignacion_valvulas/" + p.id);
    };

    const goVerAsignaciones = (p) => {
       // props.history.push("/ver_asignaciones/" + p.id);
    };*/

  return (
    <React.Fragment>
      <div className="w-full p-3 right-0">
        <div className="bg-white border rounded shadow-xl">
          <div className="border-b rounded-t p-3 bg-orange-900">
            <h5 className="font-bold uppercase text-white">
              Planes a Transplantar -{" "}
              {user && `Año: ${user.noWeek[0]}, No. Semana: ${user.noWeek[1]}`}
            </h5>
            <p className="text-white text-sm">
              Bloques listos para Transplante
            </p>
          </div>
          <div className="p-5 rounded-b">
            {/* ---- CONTENIDO --- */}
            <div className="flex mb-4">
              <div className="w-1/2 p-3">
                <Header
                  as="h3"
                  dividing
                  style={{ color: "#7B341E", paddingBottom: "5px" }}
                >
                  Planes de Siembra para Asignar Válvula
                </Header>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr className="bg-orange-900 text-white">
                      <th className="text-center text-sm border border-orange-900 px-2 py-1">
                        Flor/Variedad/Color
                      </th>
                      {/*<th className="text-center text-sm border border-orange-900 px-2 py-1">Semana Inicio</th>*/}
                      <th className="text-center text-sm border border-orange-900 px-2 py-1">
                        Transplante
                      </th>
                      <th className="text-center text-sm border border-orange-900 px-2 py-1">
                        Semana Cosecha
                      </th>
                      <th className="text-center text-sm border border-orange-900 px-2 py-1">
                        Cantidad Flores
                      </th>
                      {/*<th className="text-center text-sm border border-orange-900 px-2 py-1">Plantas</th>*/}
                      <th className="text-center text-sm border border-orange-900 px-2 py-1">
                        Charolas
                      </th>
                      {/*<th className="text-center text-sm border border-orange-900 px-2 py-1">Semillas</th>*/}
                      <th className="text-center text-sm border border-orange-900 px-2 py-1">
                        Requerimientos (m2)
                      </th>
                      {/*<th className="text-center text-sm border border-orange-900 px-2 py-1">Acciones</th>*/}
                    </tr>
                  </thead>
                  <tbody>
                    {planes.map((p, i) => {
                      return (
                        <tr key={i} className="border">
                          <td className="text-left text-sm px-2 py-1">
                            {p.flor + " " + p.variedad + " " + p.color}
                          </td>
                          {/*<td className="text-center text-sm px-2 py-1">{p.semanainicio}</td>*/}
                          <td className="text-center text-sm px-2 py-1">
                            {p.transplante}
                          </td>
                          <td className="text-center text-sm px-2 py-1">
                            {p.year - 2000 + (p.week + "").padStart(2, "0")}
                          </td>
                          <td className="text-center text-sm px-2 py-1">
                            {p.floresreq}
                          </td>
                          {/*<td className="text-center text-sm px-2 py-1">{p.plantas}</td>*/}
                          <td className="text-center text-sm px-2 py-1">
                            {p.total_entregado}
                          </td>
                          {/*<td className="text-center text-sm px-2 py-1">{p.semillas}</td>*/}
                          <td className="text-center text-sm px-2 py-1">
                            {p.totalm2}
                          </td>
                          {/*<td className="text-center text-sm px-2 py-1">
                                       {p.valvulas.length === 0 && (
                                          <button
                                             className="text-white px-2 py-1 rounded border border-orange-800 bg-orange-800 focus:border-blue-700 focus:outline-none hover:bg-orange-700"
                                             onClick={() => goAsigancion(p)}
                                          >
                                             <i className="fas fa-plus"></i> Válvula
                                          </button>
                                       )}
                                       {p.valvulas.length > 0 && (
                                          <button
                                             className="text-white text-xs px-2 py-1 rounded border border-orange-800 bg-orange-800 focus:border-blue-700 focus:outline-none hover:bg-orange-700"
                                             onClick={() => goVerAsignaciones(p)}
                                          >
                                             Ver Asignación
                                          </button>
                                       )}
                                       </td>*/}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="w-1/2 p-3">
                <Header
                  as="h3"
                  dividing
                  style={{ color: "#7B341E", paddingBottom: "5px" }}
                >
                  Seleccione la Válvula
                </Header>
                {/** Formulario para la asignación de la válvulas */}
                <Form>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label htmlFor="">Plan de Siembra:</label>
                      <Dropdown
                        fluid
                        search
                        name="planid"
                        onChange={handleChange}
                        selection
                        options={planesDrop}
                        value={form.planid}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label htmlFor="">Cantidad Flores:</label>
                      <Input
                        name="cantidad_flores"
                        onChange={handleChange}
                        type="number"
                        value={form.cantidad_flores}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label htmlFor="">Rancho: </label>
                      <Dropdown
                        fluid
                        search
                        name="ranchoid"
                        onChange={handleChange}
                        selection
                        options={ranchos}
                        value={form.ranchoid}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label htmlFor="">Válvula:</label>
                      <Dropdown
                        fluid
                        search
                        name="valvulaid"
                        onChange={handleChange}
                        selection
                        options={valvulas}
                        value={form.valvulaid}
                      />
                    </Form.Field>
                  </Form.Group>
                  {/** Datos de la válvula */}
                  {infoVal && (
                    <Table celled size="small">
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell className="center aligned">
                            Electrificada
                          </Table.HeaderCell>
                          <Table.HeaderCell className="center aligned">
                            Hoops
                          </Table.HeaderCell>
                          <Table.HeaderCell className="center aligned">
                            Micro
                          </Table.HeaderCell>
                          <Table.HeaderCell className="center aligned">
                            Sombra
                          </Table.HeaderCell>
                          <Table.HeaderCell className="center aligned">
                            Tipo Agua
                          </Table.HeaderCell>
                          <Table.HeaderCell className="center aligned">
                            Camas Totales
                          </Table.HeaderCell>
                          <Table.HeaderCell className="center aligned">
                            Camas Ocupadas
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row className="center aligned">
                          <Table.Cell>{infoVal.electrificada}</Table.Cell>
                          <Table.Cell>{infoVal.hoops}</Table.Cell>
                          <Table.Cell>{infoVal.micro}</Table.Cell>
                          <Table.Cell>{infoVal.sombra}</Table.Cell>
                          <Table.Cell>{infoVal.tipo_agua}</Table.Cell>
                          <Table.Cell>
                            Total: {infoVal.no_camas}, Ocupadas:{" "}
                            {infoVal.tot_camas_ocupadas}, Necesarias:{" "}
                            {planSelect &&
                              (+planSelect.totalm2 / +infoVal.mt2_cama).toFixed(
                                2
                              )}
                            <br />
                            Total m2:{" "}
                            <span
                              style={{ fontweight: "bold", color: "#7B341E" }}
                            >
                              {infoVal.totalm2}
                            </span>
                            <br />
                            Ocupados m2:{" "}
                            <span
                              style={{ fontweight: "bold", color: "#7B341E" }}
                            >
                              {infoVal.mt2_ocupado}
                            </span>
                          </Table.Cell>
                          <Table.Cell>
                            CI: {infoVal.val_ocupadas.ci} CF:{" "}
                            {infoVal.val_ocupadas.cf}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  )}
                  {/** Datos de la válvula */}
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label>Cama Inicial:</label>
                      <Input
                        name="cama_inicial"
                        onChange={handleChange}
                        type="number"
                        value={form.cama_inicial}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Cama Final:</label>
                      <Input
                        name="cama_final"
                        onChange={handleChange}
                        type="number"
                        value={form.cama_final}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label htmlFor="">Metros Cama Inicial</label>
                      <Input
                        name="ci_mtreos"
                        onChange={handleChange}
                        type="number"
                        style={{ textAlign: "right" }}
                        value={form.ci_metros}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label htmlFor="">Metros Cama Final</label>
                      <Input
                        name="cf_metros"
                        onChange={handleChange}
                        type="number"
                        style={{ textAlign: "right" }}
                        value={form.cf_metros}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label htmlFor="">Formula:</label>
                      <Input
                        name="formula"
                        onChange={handleChange}
                        value={form.formula}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label htmlFor="">Semana Fertilización:</label>
                      <Input
                        name="sem_fert"
                        onChange={handleChange}
                        value={form.sem_fert}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Button
                    onClick={asignar}
                    style={{
                      backgroundColor: "rgb(111, 45, 30)",
                      color: "#fff",
                    }}
                  >
                    Asignar
                  </Button>
                </Form>
              </div>
            </div>

            {/* ---- ./CONTENIDO --- */}
          </div>
        </div>
      </div>

      {/** loading **/}
      {loader && <MyLoader />}
      {/** ./loading **/}
    </React.Fragment>
  );
};

export default PlanesEjecucion;
